var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AboutMenu',{attrs:{"menu":[
    { name: '人才理念', url: '/career' },
    { name: '先进典型', url: '/careerNews/advanced' },
    { name: '员工风采', url: '/careerNews/staff' },
    { name: '人才招聘', url: '/job' },
    { name: '人资动态', url: '/human' },
    { name: '人才政策', url: '/talent' } ]}})}
var staticRenderFns = []

export { render, staticRenderFns }